export default {
  MMS_IMAGE: 'MMS Image',
  NORMAL_IMAGE: 'FriendTalk Standard Image',
  WIDE_IMAGE: 'FriendTalk Wide Image',
  MAIN_WIDE_ITEM_LIST_IMAGE: 'FriendTalk Main Wide Item List Image',
  WIDE_ITEM_LIST_IMAGE: 'FriendTalk Wide Item List Image',
  CAROUSEL_FEED_IMAGE: 'FriendTalk Carousel Feed Image',
  CAROUSEL_COMMERCE_IMAGE: 'FriendTalk Carousel Commerce Image',
  ALIMTALK_IMAGE: 'AlimTalk Image',
  ALIMTALK_ITEM_HIGHLIGHT_IMAGE: 'Highlight Image',
};
